import React from "react";
import { Route, Switch } from "react-router-dom";
import Employees from "../components/tabs/Employees/Employees";
import Clients from "../components/tabs/Clients/Clients";
import Groceries from "../components/tabs/Groceries/Groceries";
import MyCalendar from "../components/tabs/Calendar/MyCalendar";
import Recipes from "../components/tabs/Recipes/Recipes";
import Plans from "../components/tabs/Plans/Plans";
import RegisterClient from "../components/tabs/RegisterClient/RegisterClient"
import { ViewGridIcon, UserGroupIcon, UsersIcon, ClipboardListIcon, CalendarIcon, PencilAltIcon, MailIcon, AdjustmentsIcon } from '@heroicons/react/solid'
import { ClipboardListIcon as ClipboardListIconOutline, BookOpenIcon } from '@heroicons/react/outline'
import Measurements from "../components/tabs/Measurements/Measurements";
import PlanHistory from "../components/tabs/PlanHistory/PlanHistory";
import InviteForm from "../components/forms/InviteForm/InviteForm";
import AuthService from "../services/AuthService";
import Dashboard from "../components/tabs/Dashboard/Dashboard";

const ROUTES = [
    {
        path: "/home/dashboard",
        key: "Komandna tabla",
        icon: <ViewGridIcon />,
        exact: true,
        component: () => <Dashboard />,
    },
    {
        path: "/home/invite",
        key: "Pozovi",
        icon: <MailIcon />,
        exact: true,
        component: InviteForm,
    },
    {
        path: "/home/users/clients",
        key: "Klijenti",
        icon: <UserGroupIcon />,
        exact: true,
        component: Clients,
    },
    {
        path: "/home/users/employees",
        key: "Zaposleni",
        icon: <UsersIcon />,
        exact: true,
        component: Employees,
    },
    {
        collapse: false,
        path: "/home/groceries",
        key: "Namirnice",
        icon: <ClipboardListIcon />,
        exact: true,
        component: Groceries,
    },
    {
        collapse: false,
        path: "/home/measurements/:clientId",
        key: "Mere",
        icon: <AdjustmentsIcon />,
        exact: true,
        hideInSidebar: false,
        component: Measurements,
    },
    {
        collapse: false,
        path: "/home/plan-history/:clientId",
        key: "Istorija Planova",
        icon: <ClipboardListIcon />,
        exact: true,
        hideInSidebar: true,
        component: PlanHistory,
    },
    {
        collapse: false,
        path: "/home/recipes",
        key: "Recepti",
        icon: <ClipboardListIconOutline />,
        exact: true,
        component: Recipes,
    },
    {
        collapse: false,
        path: "/home/plans/:clientId/:planId",
        key: "Planovi",
        icon: <BookOpenIcon />,
        exact: false,
        component: Plans,
    },
    {
        collapse: false,
        path: "/home/calendar",
        key: "Kalendar",
        icon: <CalendarIcon />,
        exact: true,
        component: MyCalendar,
    },
    {
        collapse: false,
        path: "/register",
        key: "Registracija",
        icon: <PencilAltIcon />,
        exact: true,
        component: RegisterClient,
    },
];

export default ROUTES;

const ADMIN_ROUTES = ROUTES
const EMPLOYEE_ROUTES = [ROUTES[0], ROUTES[1], ROUTES[2], ROUTES[4], ROUTES[5], ROUTES[6], ROUTES[7], ROUTES[8], ROUTES[9]]
const ASSISTANT_ROUTES = [ROUTES[1], ROUTES[2], ROUTES[9], ROUTES[10]]

export function getRoutes() {
    let role = AuthService.getHighestRole()
    if (role === "ADMIN")
        return ADMIN_ROUTES;
    else if (role === "EMPLOYEE")
        return EMPLOYEE_ROUTES;
    else
        return ASSISTANT_ROUTES;
}


function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            exact={route.exact}
            render={props => <route.component {...props} routes={route.routes} />}
        />
    );
}

/**
* Use this component for any new section of routes (any config object that has a "routes" property
*/
export function RenderRoutes({ routes }) {
    return (
        <Switch>
            {routes.map((route, i) => {
                return <RouteWithSubRoutes key={route.key} {...route} />;
            })}
            <Route component={() => <h1>Not Found!</h1>} />
        </Switch>
    );
}